module.exports = __webpack_public_path__ + "static/media/back-arrow.bc185b46.png";